
export default {
    methods:{
        languageCheck(){
            let langCheck = document.getElementsByTagName("html")[0].hasAttribute("lang");
            if (langCheck) {
                let lang = document.getElementsByTagName("html")[0].getAttribute("lang");
                if (lang !== 'en') {
                    this.$i18n.locale = lang;
                }
            }
        },
        isMobile() {
            return window.innerWidth <= 1024
        },
        windowLocale() {
            return window && window.CTX && window.CTX.utils && window.CTX.utils.siteLocale || '';
        },
        extractSiteName(host) { 
            try {
                if(host.indexOf("author") > -1) {
                    const pathname = window.location.pathname;
                    const pathnameParts =  pathname.split('/');
                    return pathnameParts[2]
                }
                else {
                    const hostNameParts = host.split('.');
                    return hostNameParts[hostNameParts.length - 2]
                }
            } catch(error) {
            return null;
            } 
        }
    }
}